function IntegrationSelect(integrationSettingsService, integrationConstant) {
    const vm = this;
    const isOutletPlace = () => {
        return vm.location === integrationConstant.LOCATION.outletCreation.label ||
            vm.location === integrationConstant.LOCATION.outletAdmin.label;
    };
    const manageDisplay = () => {
        const integrationDetails = integrationSettingsService.integrationDetails(vm.data);
        vm.visible = {
            isPos: integrationDetails.isPos,
            isFulfilment: integrationDetails.isFulfilment,
            isOutletFeature: isOutletPlace(),
            integration: {
                display: true,
                disabled: vm.data.isUseMerchantSettings
            }
        };
    };
    vm.integrationTypes = integrationSettingsService.getIntegrationType();
    vm.changeIntegration = () => {
        vm.onChangeIntegration({type: vm.data.integration});
    };
    vm.updatePos = (posType) => {
        vm.onChangePosType({posType});
    };
    vm.updateFullData = () => {
        if (isOutletPlace() && vm.data.isUseMerchantSettings) {
            const newData = integrationSettingsService.copyWithDefaults({isUseMerchantSettings: true}, vm.parentData);
            // need to set the integration here because onchange does not call if isUseMerchantSettings is true.
            vm.data.integration = newData.integration;
            vm.onFullReload({dataToReload: newData});
        } else {
            vm.onFullReload({dataToReload: vm.data});
        }
        // need call from here but onChange cannot call if isUseMerchantSettings is true
        manageDisplay();
    };
    vm.updateData = (updatedData) => {
        vm.onDataUpdate({updatedData});
    };
    vm.cleanSubFeature = (data) => {
        vm.onToggleCleanSubFeature({data});
    };
    vm.$onInit = () => {
        vm.RADIO_YES = integrationConstant.VIEW_SETTINGS.RADIO_YES;
        vm.RADIO_NO = integrationConstant.VIEW_SETTINGS.RADIO_NO;
        vm.data = integrationSettingsService.merge({}, vm.integrationData);
        // need this check
        if (vm.data.isUseMerchantSettings) {
            vm.updateFullData();
        }
        manageDisplay();
    };
    vm.$onChanges = (changesObj) => {
        if (changesObj.integrationData && !changesObj.integrationData.currentValue.isUseMerchantSettings) {
            // Changes in the integrationData on the parent needs to be update
            vm.data = integrationSettingsService.merge({}, changesObj.integrationData.currentValue);
            manageDisplay();
        }
    };
}
angular.module('qkr.integration.settings')
    .component('integrationSelect', {
        template: require('./integration-select.html'),
        bindings: {
            integrationData: '<',
            parentData: '<?',
            integrationForm: '<',
            outletsSummaryData: '<',
            posPartners:'<',
            location: '<',
            onDataUpdate: '&',
            onChangeIntegration: '&',
            onChangePosType: '&',
            onFullReload: '&',
            onToggleCleanSubFeature: '&'
        },
        controller: IntegrationSelect,
        controllerAs: 'vm'
    });





// WEBPACK FOOTER //
// ./src/integration-settings/components/children-components/integration.select.component.js